class RadioSelects extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange(event) {

        console.log('EVENT', event.target.value)
        this.updateMasterId(event.target.value)

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateVariantInput();
        }
    }

    updateMasterId(variantId) {
        this.currentVariant = this.getVariantData().find((variant) => {
            return variant.id * 1 === variantId * 1
        });
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(
            `#product-form-${this.dataset.block}, #product-form-installment-${this.dataset.block}`
        );
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            //input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

        fetch(
            `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
            }`
        )
            .then((response) => response.text())
            .then((responseText) => {
                // prevent unnecessary ui changes from abandoned selections
                if (this.currentVariant.id !== requestedVariantId) return;

                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const destination = document.getElementById(`price-${this.dataset.section}`);
                const source = html.getElementById(
                    `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );
                const skuSource = html.getElementById(
                    `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );
                const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
                const inventorySource = html.getElementById(
                    `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );
                const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

                const volumePricingSource = html.getElementById(
                    `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );

                this.updateMedia(html);

                const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
                const pricePerItemSource = html.getElementById(
                    `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );

                const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
                const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
                const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

                if (volumeNote) volumeNote.classList.remove('hidden');
                if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
                if (qtyRules) qtyRules.classList.remove('hidden');

                if (source && destination) destination.innerHTML = source.innerHTML;
                if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
                if (skuSource && skuDestination) {
                    skuDestination.innerHTML = skuSource.innerHTML;
                    skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
                }

                if (volumePricingSource && volumePricingDestination) {
                    volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
                }

                if (pricePerItemSource && pricePerItemDestination) {
                    pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
                    pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
                }

                const price = document.getElementById(`price-${this.dataset.section}`);

                if (price) price.classList.remove('hidden');

                if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

                const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
                this.toggleAddButton(
                    addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
                    window.variantStrings.soldOut
                );

                publish(PUB_SUB_EVENTS.variantChange, {
                    data: {
                        sectionId,
                        html,
                        variant: this.currentVariant,
                    },
                });
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);
        const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
        const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('hidden');
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
        if (pricePerItem) pricePerItem.classList.add('hidden');
        if (volumeNote) volumeNote.classList.add('hidden');
        if (volumeTable) volumeTable.classList.add('hidden');
        if (qtyRules) qtyRules.classList.add('hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}
customElements.define('radio-selects', RadioSelects);


class McpLoopingTabs extends HTMLElement {

    static get observedAttributes() {
        return ['autoplay', 'speed'];
    }

    constructor() {
        super();

        this.tabList = this.querySelector('.js-tabs__controls');
        this.tabs = this.querySelectorAll('.js-tab__trigger');
        this.panels = this.querySelectorAll('.js-tab__panel');

        this.allPanels = this.querySelectorAll('.tab-features__panel');

        this.loop = 0;

        this.tabList.addEventListener('click', this.handleTabChange.bind(this));
    }

    connectedCallback() {
        if (document.querySelector('.js-tabs__images')) this.tabshasImage = true;

        if (this.hasAttribute('autoplay')) {

            const array = Array.from(this.tabs);
            let index = 0;
            let speed = 3000;

            this.getAttribute('speed') ? speed = this.getAttribute('speed') : speed;
            this.loop = setInterval(() => {
                this.deselectAllTabs();
                this.selectTab(array[index]);
                index === array.length - 1 ? index = 0 : index++;
            }, speed);
        }
    }

    disconnectedCallback() {
        clearInterval(this.loop);
        this.loop = 0;
    }

    handleTabChange(event) {
        event.preventDefault();

        //console.log('TARGET', event)
        //console.log('TARGET', this.tabList)
        if (!event.target.hasAttribute("href")) return;

        clearInterval(this.loop);
        this.loop = 0;
        this.deselectAllTabs();
        this.selectTab(event.target);
    }

    selectTab(target) {
        target.ariaSelected = true;
        let tabAttr = target.getAttribute("href");
        let selectedPanel = this.querySelector(`${tabAttr}`)
        let selectedPanelChildren = selectedPanel.querySelectorAll('.tab-features__panel');
        this.allPanels.forEach(panel => {
            panel.classList.remove('tab-features__panel--display')
        })
        selectedPanelChildren.forEach(panel => {
            panel.classList.add('tab-features__panel--display');
        })
    }

    deselectAllTabs() {
        Array.from(this.tabs).map(tab => {
            tab.ariaSelected = false;
        })
        Array.from(this.panels).map(panel => {
            panel.classList.remove('tab-features__panel--display');
        })
    };
}
customElements.define('mcp-looping-tabs', McpLoopingTabs);



if (!customElements.get('mcp-show-more')) {
    customElements.define(
        'mcp-show-more',
        class McpShowMore extends HTMLElement {
            constructor() {
                super();
                const button = this.querySelector('button');
                this.showMore = this.querySelector('.show-more');
                this.showLess = this.querySelector('.show-less');
                button.addEventListener('click', (event) => {
                    this.expandShowMore(event);
                    this.switchReadButton();
                });
            }

            expandShowMore(event) {
                this.querySelectorAll('.show-more-text').forEach((element) => element.classList.toggle('hidden'));
            }

            switchReadButton() {
                this.showLess.classList.toggle('hidden');
                this.showMore.classList.toggle('hidden');
            }
        }
    );
}


class McpPopupNotes extends HTMLElement {

    static get observedAttributes() {
        return ['content'];
    }

    constructor() {
        super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#NoteDrawer-Overlay').addEventListener('click', this.close.bind(this));
    }

    open(triggeredBy) {
        console.log("triggeredBy", triggeredBy)
        if (triggeredBy) this.setActiveElement(triggeredBy);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
            console.log('THIS', this)
            this.classList.add('animate', 'active');
        });

        this.addEventListener(
            'transitionend',
            () => {
                const containerToTrapFocusOn = document.getElementById('NoteDrawer');
                const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
                trapFocus(containerToTrapFocusOn, focusElement);
            },
            { once: true }
        );
        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.classList.remove('active');
        removeTrapFocus(this);
        document.body.classList.remove('overflow-hidden');
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}
customElements.define('mcp-popup-notes', McpPopupNotes);


class McpDrawerOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector('button');

        if (!button) return;
        button.addEventListener('click', () => {
            const popup = document.querySelector(this.getAttribute('data-popup'));
            if (popup) popup.open(button);
        });
    }
}
customElements.define('mcp-drawer-opener', McpDrawerOpener);

if (document.querySelectorAll('mcp-drawer-opener').length > 0) {
    const openers = document.querySelectorAll('mcp-drawer-opener');
    const productWrapper = document.querySelector('product-info');
    const div = document.createElement('div');
    div.classList.add('popup-notes__wrapper');
    productWrapper.insertBefore(div, openers[0]);
    openers.forEach(opener => {
        div.appendChild(opener);
    })
}

class McpMenuDrawerOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector('button');

        if (!button) return;
        button.addEventListener('click', () => {

            console.log('OPEN MENU', document.querySelector('menu-drawer'))
            document.querySelector('menu-drawer').classList.add('active')
            const popup = document.querySelector(this.getAttribute('data-popup'));
            if (popup) popup.open(button);
        });
    }
}
customElements.define('mcp-menu-drawer-opener', McpMenuDrawerOpener);


class McpAnchorNav extends HTMLElement {
    constructor() {
        super();

        this.list = this.querySelector('.js-anchor-nav__list');
        this.anchors = this.list.querySelectorAll('a[href^="#"]');

        this.scrollingSections = [...document.querySelectorAll('.anchor-content__target')];
        this.firstScrollingSection = this.scrollingSections[0];

        // declare Intersection Observer options
        this.options = {
            root: null,
            threshold: [0, 0.1],
            rootMargin: "0px 0px -50% 0px"
        };
        // instantiate the observer
        const observer = new IntersectionObserver(
            this.handleCallback.bind(this),
            this.options
        );
        this.scrollingSections.forEach((section) => {
            observer.observe(section);
        });

        this.list.addEventListener('click', this.handleClick.bind(this))
    }

    connectedCallback() {
        this.getScreenWidth();
        window.addEventListener('resize', this.getScreenWidth.bind(this));
    }


    handleCallback(entries) {
        for (const entry of entries) {
            // Make navbar fixed
            if (entry.target.id === this.anchors[0].attributes.href.value.substring(1)) {
                if (entry.boundingClientRect.y < 0) {
                    document.body.classList.add('anchor-nav-on-top')
                    this.classList.add('bar-on-top')
                } else {
                    document.body.classList.remove('anchor-nav-on-top')
                    this.classList.remove('bar-on-top')
                }
            }

            this.intersectingEntries = []

            if (entry.isIntersecting) {
                //console.log('TARGET', entry.target.id)
                this.anchors.forEach(anchor => {
                    anchor.classList.remove('anchor-nav__link--selected')
                })
                let selectedAnchor = Array.from(this.anchors).find(anchor => anchor.attributes.href.value === `#${entry.target.id}`)
                selectedAnchor.classList.add('anchor-nav__link--selected');
                let selectedAnchorPosition = selectedAnchor.getBoundingClientRect();
                //console.log('POS', selectedAnchorPosition.x)
                //console.log('POS_2', selectedAnchorPosition.x + window.scrollX)
                //this.list.scrollTo(selectedAnchorPosition.x + window.scrollX, 0);
            }
        }
    }


    handleClick(event) {
        event.preventDefault();
        //event.stopPropagation();

        let anchor = event.target.closest('a[href^="#"]');
        if (!anchor) return;
        smoothScrollTo(event, this.offset)
    }


    getScreenWidth() {
        if (window.innerWidth >= 1024) {
            this.isDesktop = true;
            this.offset = -140;
        } else {
            this.offset = -120;
            this.isDesktop = false;
        }
    };

}
customElements.define('mcp-anchor-nav', McpAnchorNav);



function easeInOutCubic(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t * t + b;
    t -= 2;
    return c / 2 * (t * t * t + 2) + b;
}

function smoothScrollTo(event, offset = 0) {
    const targetId = event.target.getAttribute('href');
    if (!document.querySelector(targetId)) return;
    const targetPosition = document.querySelector(targetId).offsetTop + offset;
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;

    //console.log('targetPosition', targetPosition)
    //console.log('startPosition', startPosition)
    //console.log('distance', distance)

    let start;
    let done = false;
    const duration = 800;

    window.requestAnimationFrame(animate);

    function animate(timeStamp) {
        if (start === undefined) {
            start = timeStamp;
        }
        const elapsed = timeStamp - start;

        //console.log('TO', easeInOutCubic(elapsed, startPosition, distance, duration))
        window.scrollTo(0, easeInOutCubic(elapsed, startPosition, distance, duration));
        if (elapsed < duration) {
            window.requestAnimationFrame(animate)
        } else {
            const scrollEnd = new CustomEvent('scrollEnd', { detail: event.target });
            dispatchEvent(scrollEnd);
        };
    }
}

/** Open externals links in new page **/
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
    }
}
